class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.duration = 500;

    // Product cards stay inert until their category is requested. The menu
    // structure remains available to the existing keyboard/category handlers.
    this.addEventListener('click', (event) => {
      const summary = event.target.closest('summary');
      if (summary && this.contains(summary)) this.hydrateProducts(summary.parentElement);
    }, true);
    this.addEventListener('toggle', (event) => {
      if (this.mainDetailsToggle.open && event.target.open) this.hydrateProducts(event.target);
    }, true);

    this.mainDetailsToggle.querySelector('summary').addEventListener('click', e => {
      const detailsElement = e.currentTarget.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
      if (isOpen) e.preventDefault();
      isOpen ? this.close() : this.open();
    })
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.content.querySelectorAll('details[open]').forEach((details) => this.hydrateProducts(details));
      // Closed menus have no layout; measure their scroll controls only when opened.
      this.content.querySelectorAll('.header__submenu__content').forEach((content) => {
        content.parentElement.querySelector('.header__submenu__navigation')?.classList.toggle(
          'hidden', content.scrollHeight <= content.clientHeight
        );
      });
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  hydrateProducts(details) {
    // Only the directly selected category, never the whole closed menu tree.
    const content = details.querySelector(':scope > .header__submenu > .header__submenu__content');
    const template = content?.querySelector('template[data-fr-nav-products]');
    if (!template) return;
    template.replaceWith(template.content);
  }

  close() {
    this.mainDetailsToggle.classList.add('no-after');
    setTimeout(() => {
      this.mainDetailsToggle.classList.remove('opening');
    }, 10);
    setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
    }, this.duration);
    document.body.classList.remove('overflow-hidden');
  }

  open() {
    setTimeout(() => {
      this.mainDetailsToggle.classList.remove('no-after');
      this.mainDetailsToggle.classList.add('opening');
    }, 10);
    document.body.classList.add('overflow-hidden');
  }
}

customElements.define('header-menu', HeaderMenu);
